import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import SEO from '@/components/common/SEO';

import FeedbackForm from './FeedbackForm';

import './FeedbackPage.css';

export default function FeedbackPage() {
    return (
        <>
            <SEO
                title="Send Feedback"
                description="Help improve RILE Connect by reporting bugs, requesting features, or sharing feedback about the platform."
                breadcrumbs={[
                    { name: 'Home', path: '/' },
                    { name: 'Feedback', path: '/feedback' },
                ]}
            />

            <section className="feedback-page bg-light py-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8} xl={6}>
                            <div className="bg-white rounded-4 shadow-sm p-4 p-md-5">
                                <FeedbackForm />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}
